// ==========================================================================
// Base
// ==========================================================================

import { lenis } from './gsap-setup.js'

// Anchor link handling:
// - <a href="#"> (empty anchor): prevent default jump-to-top.
// - <a href="#some-id">: smooth-scroll via Lenis so anchor blocks act
//   as named scroll targets without a hard jump.
document.addEventListener('DOMContentLoaded', function () {
	document.addEventListener('click', function (e) {
		const link = e.target.closest('a[href^="#"]')
		if (!link) return

		const href = link.getAttribute('href')
		if (!href || href === '#') {
			e.preventDefault()
			return
		}

		// Resolve by ID, not querySelector — handles CMS-generated IDs
		// that contain characters which aren't valid in CSS selectors
		// (':', '.', '/', etc.) and would otherwise throw.
		const id = decodeURIComponent(href.slice(1))
		const target = document.getElementById(id)
		if (!target) return

		e.preventDefault()
		lenis.scrollTo(target, { offset: -80, duration: 1.2 })

		// Keep the URL in sync so the section stays deep-linkable / shareable.
		if (window.history && history.pushState && location.hash !== href) {
			history.pushState(null, '', href)
		}
	})
})

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html & https://nystudio107.com/docs/vite/
 */
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log('HMR')
	})
}
